import { createSelector } from 'reselect'
import { State } from 'index'

const confirmSelector = (state: State) => state.confirm

export const getConfirmCollectiveStocksBreads = createSelector(
  [confirmSelector],
  (state) => state.collective_stocks.breads
)
export const getConfirmCollectiveStocksDates = createSelector(
  [confirmSelector],
  (state) => state.collective_stocks.dates
)
export const getConfirmCollectiveStocksDeletedMonth = createSelector(
  [confirmSelector],
  (state) => state.collective_stocks.deletedMonth
)
export const getConfirmHolidays = createSelector([confirmSelector], (state) => state.store.holidays)
export const getConfirmOpenTime = createSelector([confirmSelector], (state) => state.store.business_hours)
export const getConfirmOrderStartTime = createSelector([confirmSelector], (state) => state.store.order_start_time)
export const getConfirmLastOrderTime = createSelector([confirmSelector], (state) => state.store.last_order_time)
export const getConfirmLastPickupTime = createSelector([confirmSelector], (state) => state.store.last_pickup_time)
export const getConfirmStore = createSelector([confirmSelector], (state) => state.store)
export const getConfirmStoreCalendars = createSelector([confirmSelector], (state) => state.store_calendars)
export const getConfirmStoreGeoSearch = createSelector([confirmSelector], (state) => state.store_geo_search)
export const getIsBeingEdited = createSelector([confirmSelector], (state) => state.is_being_edited)
